module.exports = __webpack_public_path__ + "img/9788926887646.91ba1219.jpg";